import { Deserializable } from '../protocols/deserializable';

export class MemberAccountBalanceByLockedStatus implements Deserializable {
  public id!: number;
  public lockedBalance!: number;
  public unlockedBalance!: number;

  public onDeserialize(): void {}

  static generateFake(): MemberAccountBalanceByLockedStatus {
    const json = `{
      "id": 1,
      "lockedBalance": 25000.00,
      "unlockedBalance": 25000.00
    }`;

    return window?.injector?.Deserialize?.instanceOf(MemberAccountBalanceByLockedStatus, JSON.parse(json));
  }
}
